import React from 'react';

import Select, { ValueType } from 'react-select';
import { OptionsType } from 'types/OptionsType';

type Props = {
  // eslint-disable-next-line no-unused-vars
  onApply: (resourceId: number, onChange: ValueType<OptionsType, false>) => void;
  value: OptionsType;
  options: OptionsType[];
  resourceId: number;
};

const LookupCell: React.FC<Props> = ({ onApply, value, options, resourceId }: Props) => {
  const styles = {
    control: (base: any) => ({
      ...base,
      minHeight: null,
    }),
    menu: (base: any) => ({
      ...base,
      fontSize: '80%',
    }),
    indicatorsContainer: (base: any) => ({
      ...base,
      padding: 0,
      fontSize: '50%',
    }),
  };

  return (
    <div className="form-group" style={{ zIndex: 99999, marginBottom: 0 }}>
      <Select
        options={options}
        onChange={(value: ValueType<OptionsType, false>) => onApply(resourceId, value)}
        isClearable={false}
        menuPortalTarget={document.body}
        menuPosition={'fixed'}
        styles={styles}
        value={value}
        menuPlacement="top"
      />
    </div>
  );
};

export default LookupCell;
